import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { forkJoin } from 'rxjs';
import { ScheduleService } from '../../services/schedule.service';
import { TripsService } from '../../services/trips.service';

@Component({
  selector: 'app-schedule-route-today',
  templateUrl: './schedule-route-today.component.html',
  styleUrls: ['./schedule-route-today.component.css']
})
export class ScheduleRouteTodayComponent implements OnInit {

  public selected_route: string = "1";
  public selected_direction: string = "0";
  public selected_stop: string;
  public selected_date: string = "Today";
  public selected_service_id: string = "";
  public selected_special_service: Boolean = false;
  public current_date: any = new Date().getTime() - 600000;
  public calendar: any;
  public route_service: any;
  public timetable: any;
  public stop_times: any;
  public stops: any[];
  public first_stop: any = "";

  public service_ids: any;

  constructor(private route: ActivatedRoute, private scheduleService: ScheduleService, private tripsService: TripsService) { 

    this.selected_route = this.route.snapshot.paramMap.get('route');
    this.selected_direction = this.route.snapshot.paramMap.get('direction');
    this.selected_stop = this.route.snapshot.paramMap.get('stop');

    if(this.route.snapshot.paramMap.get('date')){
      this.selected_date = this.route.snapshot.paramMap.get('date');;
    }
    else{
      this.selected_date = this.scheduleService.get_date();
    }

  }

  ngOnInit(): void {
    this.refresh();

  }

  public refresh(): void{
    this.scheduleService.get_serivce().subscribe((data) => {

      this.calendar = data["calendar"];
      this.route_service = data["route_service"];

      var valid_service_id = this.route_service[this.selected_route];
      var active_service_id: any[] = data["calendar"][this.selected_date]["service_id"];
      this.selected_special_service = data["calendar"][this.selected_date]["special"];

      for(const service_id of valid_service_id){

        if(active_service_id.includes(service_id) && this.selected_stop != null){
          this.selected_service_id = service_id;

          var schedule = this.scheduleService.get_stop_schedule(this.selected_route, this.selected_stop, service_id);
          var realtime = this.tripsService.get_trips(this.selected_route)

          forkJoin({ scheduled: schedule, realtime: realtime}).subscribe( ({scheduled, realtime}) => {

            var entries_scheduled = Object.entries(scheduled);
            var entries_realtime = Object.entries(realtime);

            var stop_times: any = [];

              for(const schedule_trip of entries_scheduled){

                var trip = {
                  "block_id": schedule_trip[1].block_id,
                  "service_id": service_id,
                  "trip_id": schedule_trip[1]["trip_id"].slice(schedule_trip[1]["trip_id"].lastIndexOf('_') + 1),
                  "actual_trip_id": schedule_trip[1]["trip_id"],
                  "next_stop_name": "",
                  "next_stop_sequence": "",
                  "destination": schedule_trip[1].destination,
                  "vehicle_id": "",
                  "status": "Scheduled",
                  "delay": -999,
                  
                  "actual_arrival_time": schedule_trip[1].actual_arrival_time,
                  "arrival_time": schedule_trip[1].arrival_time,
                  "stop_sequence": schedule_trip[1].stop_sequence,
                  "direction_id": schedule_trip[1].direction_id,
                  "trip_headsign": schedule_trip[1].trip_headsign,
                };


                if(schedule_trip[1]["service_id"] == service_id){

                  for(const realtime_trip of entries_realtime){

                    var trip_id = schedule_trip[1]["trip_id"].slice(schedule_trip[1]["trip_id"].lastIndexOf('_') + 1);

                    if(schedule_trip[1].mode == 'rail'){
                      var split = schedule_trip[1]["trip_id"].split("_")
                      trip_id = split[2];
                    }

                    if(realtime_trip[1].trip_id == trip_id){

                      if(realtime_trip[1].delay > 0){
                        schedule_trip[1].actual_arrival_time = schedule_trip[1].actual_arrival_time - (realtime_trip[1].delay * 60);
                      }

                      trip = {
                        "block_id": realtime_trip[1].block_id,
                        "service_id": service_id,
                        "trip_id": realtime_trip[1].trip_id,
                        "actual_trip_id": schedule_trip[1].trip_id,
                        "next_stop_name": realtime_trip[1].next_stop_name,
                        "next_stop_sequence": realtime_trip[1].next_stop_sequence,
                        "destination": realtime_trip[1].destination,
                        "vehicle_id": realtime_trip[1].vehicle,
                        "status": realtime_trip[1].status,
                        "delay": realtime_trip[1].delay,
                        
                        "actual_arrival_time": schedule_trip[1].actual_arrival_time,
                        "arrival_time": schedule_trip[1].arrival_time,
                        "stop_sequence": schedule_trip[1].stop_sequence,
                        "direction_id": schedule_trip[1].direction_id,
                        "trip_headsign": schedule_trip[1].trip_headsign,
                      };
                    }
                  }
                  
                  if(this.current_date <= schedule_trip[1].actual_arrival_time){
                    stop_times.push(trip);
                  }
                }
              }

              if(stop_times.length > 0){
                this.stop_times = stop_times;
              }
          });
        }
      }
    });
  }

}
